import { useSmsSnippetQuery } from "../../../../../../api/smsSnippets/useSmsSnippetQuery";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { getPathParams } from "../utilities";

export const useData = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets",
  });

  const { id } = getPathParams();

  const { data, isFetching, isError } = useSmsSnippetQuery(
    { id },
    {
      enabled: !!id,
      onError: () => {
        uiNotification.error(t("error.getOne"));
      },
    },
  );

  return {
    isLoading: isFetching,
    isError,
    data: id ? data : null,
  };
};
